export const SIGNUP_FUNNEL_DEVICE_CATEGORY = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
} as const;

export const SIGNUP_FUNNEL_EVENT = {
  EMAIL_FOCUS: 'signup_email_focus',
  EMAIL_RESULT: 'signup_email_result',
  EMAIL_VALIDATE: 'signup_email_validate',
  FORM_FILL: 'signup_form_fill',
  FORM_VIEW: 'signup_form_view',
  SUBMIT: 'signup_submit',
  SUBMIT_RESULT: 'signup_submit_result',
  TERMS_AGREE: 'signup_terms_agree',
  UNDERREVIEW_VIEW: 'signup_underreview_view',
  VERIFY_LANDING_VIEW: 'signup_verify_landing_view',
  VERIFY_RESULT: 'signup_verify_result',
  VERIFY_WAIT_VIEW: 'signup_verify_wait_view',
} as const;

export const SIGNUP_FUNNEL_REASON = {
  DUPLICATE: 'duplicate',
  FORMAT: 'format',
  NOT_COMPANY: 'not_company',
  SERVER: 'server',
  VALIDATION: 'validation',
} as const;

export const SIGNUP_FUNNEL_RESULT = {
  EXPIRED: 'expired',
  FAIL: 'fail',
  SUCCESS: 'success',
} as const;

export const SIGNUP_FUNNEL_STAGE = {
  CONFIRM: 'confirm',
} as const;

export const SIGNUP_REQUEST_ID_STORAGE_KEY = 'STORAGE_SIGNUP_REQUEST_ID';
